import styled from 'styled-components';
import { Link } from 'react-router-dom';

const LoginLink = styled(Link)`
    padding: 1.5rem 0rem;
`;

export default LoginLink;



// WEBPACK FOOTER //
// ./src/components/atoms/form/LoginLink.js